import React,{useState,useEffect} from 'react'
import { Worker } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin,ToolbarSlot } from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail'
// Import the main component
import { LoadError, Viewer } from '@react-pdf-viewer/core'
// Import the styles
import '@react-pdf-viewer/thumbnail/lib/styles/index.css'
import '@react-pdf-viewer/core/lib/styles/index.css'

import SampleFile from '../../assets/sample.pdf'

const saveStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  fontSize: '18px',
  color: 'rgb(151 150 150)'
}

const PreviewDocxFile = ({ fileUrl,onDownloadClick=()=>{},onPrintClick=()=>{},onSaveClick=null,heightPadding='350px' }) => {
  const thumbnailPluginInstance = thumbnailPlugin()
  const [objUrl, setObjUrl] = useState(null);
  const [file, setFile] = useState(null);
  //const defaultLayoutPluginInstance = defaultLayoutPlugin()
  const { Thumbnails } = thumbnailPluginInstance

  console.log('fileUrl ', fileUrl)

  useEffect(() => {
    const fetchPDF = async () => {
      const response = await fetch(fileUrl, {
        method: 'GET',
        credentials: 'include', // to send cookies with the request
        headers: {
          // Add any other headers here
        },
      });
      const blob = await response.blob();

      // Create a local URL which points to the blob object
      let file = await new File([blob], 'Preview Docx File', {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      })

      setObjUrl(URL.createObjectURL(blob));
      setFile(file)
    };

    fetchPDF();
    // Don't forget to revoke the blob URL to avoid memory leaks
    return () => {
      if (objUrl) {
        URL.revokeObjectURL(objUrl);
      }
    };
  }, [fileUrl]);

  



  const isTabletOrIpad = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    // iPad's user agent string includes "iPad" or "Macintosh" with "Touch" in modern versions
    // due to the desktop-class browsing feature introduced in iPadOS 13.
    const isIpad = /iPad|Macintosh/.test(userAgent) && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
  
    // For Android tablets, it's trickier as the user agent does not explicitly say "Tablet",
    // but we can infer it's a tablet if it's not a mobile. This might not be 100% accurate.
    const isAndroidTablet = /Android/.test(userAgent) && !/Mobile/.test(userAgent);
  
    return isIpad || isAndroidTablet;
  };
  



  let height = '100vh'
  if(heightPadding!=''){
    height = `calc(100vh - ${heightPadding})`
  }

  return (
   <>
      <iframe frameborder="0" src={`https://view.officeapps.live.com/op/embed.aspx?src=${file}`} width="100%" height="100%" ></iframe>                            
   </>
  )
}

export default PreviewDocxFile
